/**
 * Pure helper extracted from `ArrowShape.tsx`. Lives in a sibling file
 * (not co-located with the components) so the component file only exports
 * components — required by `react-refresh/only-export-components` for HMR
 * to work without forcing a full reload on style/markup edits.
 */

export function arrowMarkerId(color: string): string {
  return `arrowhead-${color.replace('#', '')}`;
}
